export enum ServerEnvironment {
  STAGING = 'staging',
  PRODUCTION = 'production',
  TEST = 'test'
}

/* 
  The ServerContext refers to different complete enviorments.
  This includes different DB, servers, etc. 

  It will not have a staging as staging mimics production. 
*/
export enum ServerContext {
  // DEV = 'dev',
  PROD = 'prod', //
  // LOCAL = 'local',
  FUTURE = 'future'
  // TEST = 'test'
}

export declare class UnreachableCaseError extends Error {
  constructor(val: never)
}

export interface APISuccessResponse {
  success: true
  message?: string
  data: any
}
export interface APIErrorResponse {
  error: true
  message?: string
}

export interface TableDataResponse<t> {
  rows: t[]
  total: number
  pageCount: number
}
